/* eslint-disable */
// @ts-nocheck
import { AnyAction } from 'redux';
import { reducerWrapper } from '../../support/utils';
import { FETCH_MAU_LIMIT, FETCH_MAU_OVERAGE_COST, FETCH_MAU_COUNT_DATA } from '../../actions/Usage/mau/MauUsageActions';
import { MauCount } from '../../../../../shared/types';

type ReducerUsageData = {
  mauLimit: number;
  mauOverageCost: number;
};

export type UsageReducer = {
  loading: boolean;
  error: any;
  usageData: ReducerUsageData;
  countData: MauCount['data'];
};

const INIT_STATE: UsageReducer = {
  loading: true,
  error: null,
  usageData: {} as ReducerUsageData,
  countData: [] as MauCount['data'],
};

const Handler = (state: UsageReducer, action: AnyAction): UsageReducer => {
  switch (action.type) {
    case FETCH_MAU_LIMIT.response:
      return {
        ...state,
        loading: false,
        usageData: {
          ...state.usageData,
          mauLimit: action.data,
        },
      };
    case FETCH_MAU_OVERAGE_COST.response:
      return {
        ...state,
        loading: false,
        usageData: {
          ...state.usageData,
          mauOverageCost: action.data?.data,
        },
      };
    case FETCH_MAU_COUNT_DATA.response:
      return {
        ...state,
        loading: false,
        countData: action.data?.data,
      };
    default:
      return state;
  }
};

const Usage = reducerWrapper(INIT_STATE, Handler, {
  request: [FETCH_MAU_LIMIT, FETCH_MAU_OVERAGE_COST, FETCH_MAU_COUNT_DATA],
  error: [FETCH_MAU_LIMIT, FETCH_MAU_OVERAGE_COST, FETCH_MAU_COUNT_DATA],
});

export default Usage;
